// extracted by mini-css-extract-plugin
module.exports = {"paginationControl":"Hooks_paginationControl__3v9dD","paginationControlPlaceholder":"Hooks_paginationControlPlaceholder__2oJjB"};